import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import localeIt from 'vee-validate/dist/locale/it'

Validator.localize('it', localeIt)
Vue.use(VeeValidate, {
  locale: 'it'
})



// WEBPACK FOOTER //
// ./src/front/init/utils/validator.js